import { render, staticRenderFns } from "./ChargeTaskDetail.vue?vue&type=template&id=674ba252&scoped=true"
import script from "./ChargeTaskDetail.vue?vue&type=script&lang=js"
export * from "./ChargeTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ChargeTaskDetail.vue?vue&type=style&index=0&id=674ba252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ba252",
  null
  
)

export default component.exports